<template>
  <div class="container px-0">
    <Avatar
      image="https://s3.eu-central-1.amazonaws.com/uploads.mangoweb.org/shared-prod/visegradfund.org/uploads/2021/08/placeholder-male.jpg"
      class="flex items-center justify-center mr-2 profile-image"
      size="xlarge"
      shape="circle"
    />

    <div class="body-container px-0">
      <div class="main-content px-0">
        <section class="py-0 py-md-5 px-0">
          <div class="container p-0">
            <div class="row justify-content-center">
              <div
                class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4"
              >
                <div
                  class="card border border-light-subtle rounded-3 shadow-sm"
                >
                  <div class="card-body p-3 p-md-4 p-xl-5">
                    <h2 class="fs-5 fw-normal text-center text-secondary mb-4">
                      Данные пользователя
                    </h2>
                    <div class="row gy-2 overflow-hidden">
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputMask
                              id="uid"
                              class="w-100 text-left"
                              size="large"
                              v-model="user.uid"
                              mask="999-999"
                              readonly
                              style="color: #a8a8a8"
                            />
                            <label for="uid">Ваш UID</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputText
                              id="first_name"
                              class="w-100"
                              size="large"
                              v-model="user.last_name"
                            />
                            <label for="first_name">Фамилия</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputText
                              id="last_name"
                              class="w-100"
                              size="large"
                              v-model="user.first_name"
                            />
                            <label for="last_name">Имя</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputText
                              id="mid_name"
                              class="w-100"
                              size="large"
                              v-model="user.middle_name"
                            />
                            <label for="mid_name">Отчество</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <IconField>
                              <InputMask
                                id="bdate"
                                class="w-100"
                                size="large"
                                v-model="formattedBirthDate"
                                mask="99.99.9999"
                                autocomplete="off"
                                style="color: #a8a8a8"
                                readonly
                              />
                              <InputIcon class="pi pi-calendar" />
                            </IconField>
                            <label for="bdate"
                              >Дата рождения [дд.мм.гггг]</label
                            >
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel class="w-full md:w-100" variant="on">
                            <Select
                              v-model="user.sex"
                              :options="[
                                { name: 'Мужской', value: 'male' },
                                { name: 'Женский', value: 'female' },
                              ]"
                              optionLabel="name"
                              placeholder="Выберите пол"
                              class="w-100 text-start"
                              optionValue="value"
                              inputId="namesex"
                              size="large"
                            />
                            <label for="namesex" v-if="user.sex">Пол</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputMask
                              id="phone"
                              class="w-100"
                              size="large"
                              v-model="user.phone_number"
                              mask="+7 (999) 999-99-99"
                              style="color: #a8a8a8"
                              readonly
                            />
                            <label for="phone">Телефон</label>
                          </FloatLabel>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating mb-3">
                          <FloatLabel variant="on">
                            <InputText
                              name="email"
                              type="text"
                              class="w-100"
                              size="large"
                              v-model="user.email"
                              readonly
                              style="color: #a8a8a8"
                            />

                            <label for="email">Email</label>
                          </FloatLabel>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="d-grid px-2 py-3 py-md-5">
          <Button
            label="Сохранить"
            severity="success"
            rounded
            raised
            @click="handleSave"
          />
        </div>
        <div class="col-12">
          <div class="d-grid my-2 px-2">
            <Button
              label="Выйти из аккаунта"
              icon="pi pi-sign-out"
              iconPos="left"
              severity="info"
              @click="SignOut"
              variant="text"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="d-grid mt-5 px-2">
            <Button
              label="Удалить аккаунт"
              icon="pi pi-trash"
              severity="danger"
              rounded
              @click="() => {}"
              variant="outlined"
            />
          </div>
        </div>
        <div class="col-12">
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { loadFromLocalDB, clearAll } from "@/services/dataService";
import {
  setAuthorizationToken,
  fetchUserProfile,
  logout,
} from "@/services/api";
import Select from "primevue/select";

export default defineComponent({
  setup() {
    const user = ref({
      first_name: "",
      last_name: "",
      middle_name: "",
      birth_date: "",
      sex: "",
      phone_number: "",
      email: "",
      uid: "",
    });
    const router = useRouter();
    const formattedBirthDate = computed(() => {
      if (!user.value.birth_date) return "";
      const [year, month, day] = user.value.birth_date.split("-");
      return `${day}.${month}.${year}`;
    });

    const loadProfile = async () => {
      try {
        // Сначала пробуем загрузить из локальной БД
        let profileData = await loadFromLocalDB("profile");

        // Если данных нет в локальной БД, загружаем с сервера
        if (!profileData) {
          profileData = await fetchUserProfile();
        }

        if (profileData) {
          // Преобразуем значение пола для соответствия формату Select
          profileData.sex = profileData.sex === "Мужской" ? "male" : "female";
          user.value = profileData;

          // Сохраняем данные для расчета рисков в localStorage
          const userData = {
            gender: profileData.sex,
            birth_date: profileData.birth_date,
          };
          localStorage.setItem("user_data", JSON.stringify(userData));
          console.log(
            "Данные пользователя сохранены в localStorage для расчета рисков:",
            userData
          );
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных профиля:", error);
      }
    };

    const handleSave = async () => {
      // TODO: Реализовать сохранение изменений профиля
      console.log("Сохранение профиля...", user.value);
    };

    const SignOut = async () => {
      try {
        // Сначала выполняем выход на сервере
        await logout();

        // Удаляем куки с токеном
        document.cookie =
          "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        // Очищаем локальные данные
        await clearAll();

        // Очищаем заголовок авторизации в axios
        setAuthorizationToken("");

        console.log("Выход выполнен успешно");

        // Перенаправляем на страницу входа
        router.push({ name: "SignIn" });
      } catch (error) {
        console.error("Ошибка при выходе из системы:", error);
        throw new Error("Не удалось выполнить выход из системы");
      }
    };

    onMounted(() => {
      loadProfile();
    });

    return {
      user,
      formattedBirthDate,
      SignOut,
      handleSave,
    };
  },
  components: {
    Select,
  },
});
</script>

<style lang="css" scoped>
.container {
  max-width: 480px;
  margin: 0 auto;

  border-radius: 12px;
  padding: 24px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.back-button {
  color: #333;
  text-decoration: none;
  margin-right: 16px;
  font-size: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto 24px;
  display: block;
  background: #e0e0e0;
}
</style>
